import React, { useState, useEffect } from 'react';
import './index.css';
import { isValidUser } from '../Utils/authUtils';
import { user } from '@ohif/core';
import { ICONS, Loader, SuccessModal } from '@ohif/ui';
import classnames from 'classnames';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { loginValidationSchema, loginInitialValues } from './helper/schema';
import { LoginFormTypes } from './helper/auth';
import { useDispatch, useSelector } from 'react-redux';
import loginApi from '../rtk-apis/authentication/login';
import { AppDispatch, RootState } from '../store/store';
import { closeModal } from '@custom/store/slices/authentication/login';
import { kcDcmTokenApi } from '@custom/rtk-apis/authentication/kc-dcm-token';
import { KC_CLIENT_ID, KC_CLIENT_SECRET, KC_GRANT_TYPE } from '@custom/constant';
import { clearkcDcmTokenState } from '@custom/store/slices/authentication/kc-dcm-token';
import { localKcDcmTokenApi } from '@custom/rtk-apis/authentication/local-kc-dcm-token';
import { savePACSToSessionStorage } from '@custom/Utils/localPACSutils';
import { clearLocalKcDcmTokenState } from '@custom/store/slices/authentication/local-kc-dcm-token';
import { _roleType } from '@custom/Utils/constants/appConstants';

const Login = props => {
  const [showPassword, setShowPassword] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [load, setLoad] = useState(false)
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const loginRespose = useSelector((state: RootState) => state?.loginResponse);
  const kcDcmTokenResponse = useSelector((state: RootState) => state.kcDcmTokenResponse);
  const localKcDcmTokenResponse = useSelector((state: RootState) => state.localKcDcmTokenResponse);
  const navigate = props.route.prop();

  const handleLogin = async (values: LoginFormTypes, { setSubmitting, setFieldError }: any) => {
    sessionStorage.removeItem('shareAuthToken')
    try {
      setSubmitting(true);
      setLoad(true);

      const normalizedValues = { ...values, email: values.email.toLowerCase() };

      const res = await dispatch(loginApi(normalizedValues)).unwrap();

      if (res?.accessToken) {
        setRememberMe(values.rememberMe);
        const storage = values.rememberMe ? localStorage : sessionStorage;
        storage.setItem('role', res?.userDetails?.role);
        storage.setItem('name', res?.userDetails?.name);
        storage.setItem('email', res?.userDetails?.email);
        storage.setItem('token', res?.accessToken);
        storage.setItem('userId', res?.userDetails?._id);
        storage.setItem('previousRoleFlag', res?.userDetails?.previousRole);
        storage.setItem('profilePic', res?.userDetails?.profilePic || '');
        if (res?.userDetails?.mustChangePassword) {
          storage.setItem('mustChangePassword', 'true');
          setLoad(false);
          dispatch(closeModal());
          navigate('/resetPassword', {
            state: { email: res?.userDetails?.email, initialPasswordChange: true },
          });
          return;
        }
        storage.removeItem('mustChangePassword');
        if (values.rememberMe === true) {
          storage.setItem('token', res?.accessToken);
        }

        if (res.userDetails.role !== 'Superadmin') {
          storage.setItem('hospitalId', res?.userDetails?.hospitalId);
          storage.setItem('hospitalName', res?.userDetails?.hospitalDetail?.hospitalName);
          storage.setItem('hospitalCode', res?.userDetails?.hospitalDetail?.hospitalCode);
          storage.setItem('hospitalType', res?.userDetails?.hospitalDetail?.hospitalType);
          if (res?.userDetails?.hospitalDetail?.teleradiology) {
            storage.setItem('teleradiology', JSON.stringify(res?.userDetails?.hospitalDetail?.teleradiology));
          } else {
            storage.setItem('teleradiology', JSON.stringify(false));
          }
        }
        else {
          storage.setItem('hospitalId', '5b0d9b4718be123d3d3e3f439234a694');
          storage.setItem('hospitalName', 'superadmin-teleradiology');
          // storage.setItem('hospitalCode', res?.userDetails?.hospitalDetail?.hospitalCode);
          storage.setItem('hospitalType', 'teraradiology');
        }

        if (res?.userDetails?.role === _roleType.frontDesk) {
          storage.setItem('canApproveDiscount', res?.userDetails?.canApproveDiscount);
        }

        if (res?.userDetails?.hospitalDetail?.hospitalType == 'teraradiology' && (res.userDetails.role === 'Radiologist' || res.userDetails.role === 'Resident')) {
          storage.setItem('user_code', res?.userDetails?.user_code);
        }

        localStorage.setItem("selectedTheme", "light");
        localStorage.setItem("isLightMode", String(true));

        if (res.userDetails.pacsDetail.length > 0) {
          const LocalPacsInfo = res.userDetails.pacsDetail.filter((pac: any) => {
            return pac.active === true
          })

          if (LocalPacsInfo.length === 1) {
            const localParams = new URLSearchParams();
            localParams.append('client_id', LocalPacsInfo[0].kcClientId);
            localParams.append('client_secret', LocalPacsInfo[0].kcClientSecret);
            localParams.append('grant_type', KC_GRANT_TYPE);
            localParams.append('kc_url', LocalPacsInfo[0].kcURL);
            await dispatch(localKcDcmTokenApi(localParams)).unwrap().catch((err) => {
              console.log('Local PACS Error', err);
              setErrorMessage('Local PACS token error');
            });
          }

          const sanitizedLocalPacsInfo = LocalPacsInfo.map(pac => {
            const { kcURL, kcClientId, kcClientSecret, ...rest } = pac;
            return rest;
          });

          savePACSToSessionStorage('LOCAL_PACS_INFO', sanitizedLocalPacsInfo);
        }
        user.getAccessToken = () => res?.accessToken;

        const params = new URLSearchParams();
        params.append('client_id', KC_CLIENT_ID);
        params.append('client_secret', KC_CLIENT_SECRET);
        params.append('grant_type', KC_GRANT_TYPE);

        await dispatch(kcDcmTokenApi(params)).unwrap().catch((err) => {
          console.error('PACS token error:', err);
          setErrorMessage('PACS token error');
        });

        setLoad(false);
        dispatch(closeModal());
        console.log("%c hospitalType", "color: red;", res?.userDetails?.hospitalDetail?.hospitalType, res?.userDetails?.hospitalDetail?.hospitalType !== 'teraradiology');
        if (
          res?.userDetails?.role !== 'Superadmin' &&
          res?.userDetails?.hospitalDetail?.hospitalType !== 'teraradiology' &&
          (!res?.userDetails?.daysLeft || res?.userDetails?.daysLeft <= 0)
        ) {
          navigate('/edithospital', { state: { showModal: true } });
        } else {
           if(res?.userDetails?.role === 'technicianradiology'){
            navigate('/appointments');
           } else {
            navigate('/dashboard');
           }
        }
        console.log("Login successful", res.userDetails);
        window.location.reload();
      } else {
        setFieldError('apiErr', res?.message || 'Login failed. Please try again.');
        setErrorMessage('Login failed. Please try again.');
        setTimeout(() => setErrorMessage(""), 1500);
      }
    } catch (error) {
      setFieldError('apiErr', error?.msg || 'An unexpected error occurred.');
      setLoad(false);
      setErrorMessage(error?.msg || 'Invalid Credentials');
      setTimeout(() => setErrorMessage(""), 2000);
    } finally {
      setLoad(false);
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (isValidUser()) {
      const role = sessionStorage.getItem('role') || localStorage.getItem('role');
      if (role === 'technicianradiology') {
        navigate('/appointments');
      } else {
        navigate('/dashboard');
      }
    }
  }, []);

  useEffect(() => {
    if (kcDcmTokenResponse?.status === 'SUCCESS' && kcDcmTokenResponse?.result?.access_token) {
      if (rememberMe) {
        localStorage.setItem('cloud_pacs_access_token', kcDcmTokenResponse?.result?.access_token);
      } else {
        sessionStorage.setItem('cloud_pacs_access_token', kcDcmTokenResponse?.result?.access_token);
      }
      dispatch(clearkcDcmTokenState());
    } else {
      console.error('Error in PACS authentication.');
    }
    if (kcDcmTokenResponse.status == 'ERROR') {
      setErrorMessage('PACS token error');
    }
  }, [dispatch, kcDcmTokenResponse, kcDcmTokenResponse.status]);

  useEffect(() => {
    if (localKcDcmTokenResponse?.status === 'SUCCESS' && localKcDcmTokenResponse?.result?.access_token) {
      if (rememberMe) {
        localStorage.setItem('local_pacs_access_token', localKcDcmTokenResponse?.result?.access_token);
      } else {
        sessionStorage.setItem('local_pacs_access_token', localKcDcmTokenResponse?.result?.access_token);
      }
      dispatch(clearLocalKcDcmTokenState());
    } else {
      console.error('Error in LOCAL PACS authentication.');
    }
    if (localKcDcmTokenResponse.status == 'ERROR') {
      setErrorMessage('LOCAL PACS token error');
    }
  }, [dispatch, localKcDcmTokenResponse, localKcDcmTokenResponse.status]);


  return (
    <div
      className={classnames("h-screen w-full bg-cover bg-no-repeat bg-center")}
      style={{
        backgroundImage: "url('/assets/BG.png')",
        backgroundColor: '#eaf4f2',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition:'right top',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <div className="flex justify-between items-start p-4">
        <img
          src={ICONS.SevenHillsLogo}
          alt="Seven Hills Logo"
        />
        <div
          className="fixed-bottom-right"
        >
          <img
            src={ICONS.GDPR}
            style={{
              width: '100px',
              height: 'auto',
              borderRadius: '12px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              padding: '8px',
            }}
            alt="GDPR"
          />
          <img
            src={ICONS.Hippa}
            style={{
              width: '120px',
              height: 'auto',
              borderRadius: '12px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              padding: '8px',
            }}
            alt="HIPAA"
          />
        </div>
      </div>

      <div className={classnames("login-container w-[400px] h-[420px] p-6 bg-white text-black mx-auto mt-20 mb-10 rounded-lg border border-gray-300 shadow-lg")}>
        <div className={classnames("flex flex-col justify-center items-center mb-4")}>
          <img className='w-12 h-12 mb-2' src={`${ICONS.UserIconLight}`} alt="User_Icon" />
          <h1 className={classnames('text-black font-bold text-xl')}>Login into your Account</h1>
        </div>
        <Formik
          initialValues={loginInitialValues}
          validationSchema={loginValidationSchema}
          onSubmit={handleLogin}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form>
              <div className={classnames("flex flex-col gap-[3px] my-[15px]")}>
                <label className='form__label' htmlFor='email'>Email Address</label>
                <div className='form__Field relative w-full'>
                  <Field
                    name='email'
                    type='email'
                    placeholder='Enter your email address'
                    className={classnames('form__input form__input--email')}
                  />
                </div>
                <ErrorMessage name='email' component='span' className='form__error' />
              </div>
              <div className={classnames("flex flex-col gap-[3px] my-[15px] mt-4")}>
                <label className='form__label' htmlFor='password'>Password </label>
                <div className='form__Field relative w-full'>
                  <Field
                    name='password'
                    type={showPassword ? "text" : "password"}
                    placeholder='Enter your password'
                    className={classnames('form__input form__input--password')}
                  />
                  <img
                    className={classnames('iconPassword')}
                    src={`${ICONS.PasswordEye}`}
                    alt="password eye"
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </div>
                <ErrorMessage name='password' component='span' className='form__error' />
              </div>

              <div className="flex justify-between items-center mt-4 mb-3">
                <div className={classnames('form__checkbox')}>
                  <div className="form__checkbox__option m_0">
                    <Field type="checkbox" name="rememberMe" id="remember_me" className={classnames('form__checkbox__input')} />
                    <label className={classnames('form__checkbox__label')} htmlFor="remember_me">
                      Remember me
                    </label>
                  </div>
                </div>
                <label
                  className={classnames('text-base font-medium underline cursor-pointer text-inputfield-main')}
                  style={{ fontSize: '14px', color: '#51A196', textDecoration: 'underline' }}
                  onClick={() => {
                    navigate('/forgotPassword')
                  }}>
                  Forgot Password ?
                </label>
              </div>
              <p className='form__error' style={{ textAlign: "center", fontSize: "14px" }}>
                {errorMessage}
              </p>
              <div className='btn__group btn__group--full'>
                <button type="submit" disabled={isSubmitting} className='btn btn__primary btn--full'>
                  {isSubmitting ? 'Logging in...' : 'Login'}
                </button>

              </div>
            </Form>
          )}
        </Formik>
      </div>

      <Loader isLoaderOpen={load} />

      <SuccessModal
        isSuccessModalOpen={successPopup}
        title={'Login Successfully.'}
        handleCloseModal={() => setSuccessPopup(false)}
      />

      <div className="text-center text-sm text-[#000000] mt-4">
        © 2025 Svensa Solutions LLC, UAE - Svensa Images. <br />
        All rights reserved.
      </div>
    </div>
  );
};
export default Login;
